<template>
  <!-- <div
    v-if="authStore.isAuthenticated && authStore.user.isDefaultPassword"
    class="pa-0"
  >
    <v-row justify="start" class="mb-6">
      <v-col cols="12">
        <div class="text-start">
          <v-card
            title="กรุณาเปลี่ยนรหัสผ่านก่อนดู PLO"
            class="mx-auto mt-5 pa-4 pa-sm-6 text-center"
            max-width="1000"
          >
            <v-card-actions>
              <v-btn
                variant="elevated"
                color="pink"
                @click="
                  (authStore.editAccount = true), (authStore.isEditing = true)
                "
              >
                เปลี่ยนรหัสผ่าน
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div> -->

  <v-row
    justify="start"
    class="mt-0 ms-n5"
    v-if="authStore.user && authStore.user.PLO"
  >
    <v-col cols="12" md="8">
      <v-card elevation="10">
        <v-card-title class="bg-pink white--text d-flex align-center">
          <v-icon class="mr-2" color="white">mdi-chart-line</v-icon>
          ผลการเรียน PLO (Program Learning Outcomes)
        </v-card-title>

        <v-card-text class="pa-4">
          <v-expansion-panels variant="accordion" multiple>
            <v-expansion-panel
              v-for="(yearData, yearKey) in authStore.user.PLO"
              :key="yearKey"
            >
              <v-expansion-panel-title
                class="text-subtitle-1 text-sm-h6 font-weight-medium"
              >
                <div class="d-flex align-start w-100">
                  <v-icon class="mr-3" color="primary"
                    >mdi-calendar-range</v-icon
                  >
                  <div class="flex-grow-1">
                    <div class="text-subtitle-1 font-weight-bold">
                      เกณฑ์การพิจารณา {{ yearKey }}
                      <!-- คลิกเพื่อดูรายละเอียด -->
                    </div>
                    <div class="text-caption text-medium-emphasis">
                      คลิกเพื่อดูรายละเอียด
                    </div>
                  </div>
                </div>
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-expansion-panels multiple flat>
                  <v-expansion-panel
                    v-for="(ploData, ploKey) in yearData"
                    :key="ploKey"
                  >
                    <v-expansion-panel-title
                      class="text-subtitle-1 text-sm-h6 font-weight-medium"
                    >
                      <div class="d-flex align-start w-100">
                        <v-icon class="mr-3" color="primary">
                          {{
                            `mdi-numeric-${parseInt(
                              ploKey.replace("PLO", "")
                            )}-circle`
                          }}
                        </v-icon>
                        <div class="flex-grow-1">
                          <div class="text-subtitle-1 font-weight-bold">
                            {{ getPloname(ploKey) }}
                          </div>
                          <div class="text-caption text-medium-emphasis">
                            คลิกเพื่อดูรายละเอียด
                          </div>
                        </div>
                      </div>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text class="pa-0">
                      <v-list
                        v-if="'Score' in ploData"
                        class="text-left"
                        lines="one"
                      >
                        <v-list-item>
                          <v-list-item-title class="font-weight-medium"
                            >Score</v-list-item-title
                          >
                          <template v-slot:append>
                            <div class="text-right">
                              <span
                                class="text-subtitle-1 font-weight-bold"
                                :style="{ color: getScoreColor(ploData.Score) }"
                              >
                                {{ ploData.Score }}
                              </span>
                              <div class="text-caption text-medium-emphasis">
                                คะแนน
                              </div>
                            </div>
                          </template>
                        </v-list-item>
                      </v-list>

                      <v-list v-else class="text-left" lines="one">
                        <v-list-item
                          v-for="(score, subjectKey) in ploData"
                          :key="subjectKey"
                        >
                          <v-list-item-title class="font-weight-medium">
                            {{ subjectKey }}
                          </v-list-item-title>
                          <template v-slot:append>
                            <div class="text-right">
                              <span
                                class="text-subtitle-1 font-weight-bold"
                                :style="{ color: getScoreColor(score) }"
                              >
                                {{ getScore(score) }}
                              </span>
                              <div
                                class="text-caption text-medium-emphasis"
                                :class="{
                                  hidden: isNotNum,
                                }"
                              >
                                คะแนน
                              </div>
                            </div>
                          </template>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useAuthStore } from "@/stores/auth";
import { getCurrentInstance } from "vue";
let isNotNum = false;
const { proxy } = getCurrentInstance();
const authStore = useAuthStore();
import axios from "axios";
const API_BASE_URL = process.env.VUE_APP_BACKEND_BASE_URL;
const searchOption = ref("studentNum");

const getScore = (score) => {
  if (score === null || score === undefined) return score;
  const s = String(score).toLowerCase();

  if (s === "pass") {
    isNotNum = true;
    return "Pass";
  }
  if (s === "not pass") {
    isNotNum = true;
    return "Not Pass";
  }
  if (s === "in progress") {
    isNotNum = true;
    return "In Progress";
  }
  if (isNaN(score)) {
    isNotNum = true;
    return score;
  }

  isNotNum = false;
  return score;
};

const getScoreColor = (score) => {
  if (score === null || score === undefined) return "inherit";
  const s = String(score).toLowerCase();

  if (s === "pass") {
    return "rgb(var(--v-theme-success))";
  }
  if (s === "not pass") {
    return "rgb(var(--v-theme-error))";
  }
  if (s === "in progress") {
    return "rgb(var(--v-theme-warning))";
  }
  if (!isNaN(score)) {
    if (Number(score) >= 50) return "rgb(var(--v-theme-success))";
    if (Number(score) >= 30) return "rgb(var(--v-theme-warning))";
    return "rgb(var(--v-theme-error))";
  }

  return "rgb(var(--v-theme-error))";
};

const getPloname = (subjectKey) => {
  if (subjectKey.toLowerCase() == "plo1") {
    return "PLO 1: Volunteer activities";
  }
  if (subjectKey.toLowerCase() == "plo2") {
    return "PLO 2: Ethical skill";
  }
  if (subjectKey.toLowerCase() == "plo3") {
    return "PLO 3: Innovative & Res";
  }
  if (subjectKey.toLowerCase() == "plo4") {
    return "PLO 4: Critical skill";
  }
  if (subjectKey.toLowerCase() == "plo5") {
    return "PLO 5: Life-long learning";
  }
  if (subjectKey.toLowerCase() == "plo6") {
    return "PLO 6: Leadership skill";
  }
  if (subjectKey.toLowerCase() == "plo7") {
    return "PLO 7: Commune & IT skill";
  }
  if (subjectKey.toLowerCase() == "plo8") {
    return "PLO 8: OSCE";
  } else {
    return "PLO name not Found";
  }
};
</script>

<style scoped>
.hidden {
  display: none;
}
</style>
